import { Injectable } from '@angular/core';
import { ChangeInvestmentInstructionSubmissionTypeEnum } from '../../../../models/enum/shared/change-investment-instruction-submission-type.enum';
import { AccountTypeIdEnum } from '../../../../models/enum/shared/account-type-id.enum';

@Injectable({
  providedIn: 'root'
})
export class InvestmentInstructionSubmissionFormService {
  public selectedSubmissionType: ChangeInvestmentInstructionSubmissionTypeEnum | null = null;
  public setSelectedSubmissionType = (type: ChangeInvestmentInstructionSubmissionTypeEnum | null) => {
    this.selectedSubmissionType = type;
  };

  public selectedAccountTypeId: AccountTypeIdEnum | null = null;
  public setSelectedAccountTypeId = (type: AccountTypeIdEnum | null) => {
    this.selectedAccountTypeId = type;
  };

  public selectedAccountId: number | null = null;
  public setSelectedAccountId = (id: number | null) => {
    this.selectedAccountId = id;
  };
}
